import { useTranslation } from 'react-i18next'

type Indicator = 'green' | 'amber' | 'red'

const DOT: Record<Indicator, string> = {
  green: 'bg-success',
  amber: 'bg-warning',
  red: 'bg-danger',
}

/** USP #1 — colored status pill for the dashboard / health page. */
export function AccountHealthBadge({ indicator }: { indicator: Indicator }) {
  const { t } = useTranslation('banking')
  const label =
    indicator === 'green'
      ? t('health.indicator_green')
      : indicator === 'amber'
        ? t('health.indicator_amber')
        : t('health.indicator_red')

  return (
    <span className="inline-flex items-center gap-2 text-sm">
      <span className={['h-2.5 w-2.5 rounded-full', DOT[indicator]].join(' ')} aria-hidden="true" />
      {label}
    </span>
  )
}
